import { post } from '@/services/apiClient';

interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

interface ChatResponse {
  reply: string;
  remaining: number;
}

export async function sendChatMessage(
  messages: ChatMessage[],
  language: string
): Promise<ChatResponse> {
  return post<ChatResponse>('/api/v1/chatbot/chat', { messages, language }, { skipAuth: true });
}
